import { useState } from 'react'
import TextField, { TextFieldProps } from 'baby-ui/foundation/TextField'

const FirstNameTextField = (props: TextFieldProps) => {
  const [showHelperText, setShowHelperText] = useState(false)

  return (
    <TextField
      {...(props as any)}
      helperText={
        showHelperText &&
        "Search for any provider's name if you receive care at a group practice"
      }
      onBlur={() => setShowHelperText(false)}
      onFocus={() => setShowHelperText(true)}
    />
  )
}

export default FirstNameTextField
